
  /**
   * 
   * @param {*} matchListRequirementItem 
   * itemRequirements:{
   *  propertys: [
   *    {
   *      pid: p1
   *      items: [
   *        {name: X, price: 0, uid: u1},  
   *        {name: X, price: 0, uid: u2},  
   *      ]
   *    },
   *    {
   *      pid: p2
   *      items: [
   *        {name: X, price: 0, uid: u3},  
   *        {name: X, price: 0, uid: u4},  
   *      ]
   *    },
   *  ]

   *  {
   *    pid: p1
   *    items: [
   *      {name: X, price: 0, uid: u1},  
   *      {name: X, price: 0, uid: u2},  
   *    ]
   *  },
   *  {
   *    pid: p2
   *    items: [
   *      {name: X, price: 0, uid: u3},  
   *      {name: X, price: 0, uid: u4},  
   *    ]
   *  },
   * }
   *  
   * @returns 一个keys数组
   * 
   * [
   *  'p1-u1',
   *  'p1-u2',
   *  'p2-u3',
   *  'p2-u4',
   * ]
   */
  function _createReqKeys(matchListRequirementItem) {
    let keys = [];
    (matchListRequirementItem.propertys || []).map(req => {
      (req.items || []).map(item => {
        keys.push(`${req.pid}-${item.uid}`)
      })
    })
    return keys
  }

  /**
   * 
   * @param {*} comboProducts 
   * comboProducts:[
   *  {
   *    pid: p1,
   *    num: 1,
   *  },
   *  {
   *    pid: p2,
   *    num: 3,
   *  },
   * ]
   *  
   * @returns 一个keys数组
   * 
   * [
   *  'p1-1',
   *  'p2-2',
   * ]
   */
  function _createComboKeys(comboProducts) {
    let keys = [];
    comboProducts.map(pro => {
      keys.push(`${pro.pid}-${pro.num}`)
    })
    return keys
  }

    /**
   * 购物车餐品 生成key
   */
   function _createCartProKey(cartPro) {
      let proKey = (cartPro.pid > 0 ? cartPro.pid : cartPro.name) + 'x' + cartPro.num,
      reqKeys = [],
      comboKeys = [];
  
  
      if(cartPro.matchListRequirementItem) {
        reqKeys = _createReqKeys(cartPro.matchListRequirementItem)
      }
      if(cartPro.type == 2 && cartPro.products) {
        comboKeys = _createComboKeys(cartPro.products || [])
      }
  
      return {
        id: cartPro.pid > 0 ? cartPro.pid : cartPro.name,
        proKey,
        reqKeys,
        comboKeys,
      }
  
    }
    /**
   * 购物车容错餐品 生成key
   */
   function _createOutMenuCartProKey(cartPro) {
      let proKey = cartPro.pid + 'x' + cartPro.num,
      reqKeys = [],
      comboKeys = [];

      return {
        outMenu: true,
        id: cartPro.pid > 0 ? cartPro.pid : cartPro.name,
        proKey,
        reqKeys,
        comboKeys,
      }
  
    }


let cartProCompareHelper = {


  createCartProsKey(cartPros = [], outMenuPros = []) {
    let keys = [];
    cartPros.map(pro => {
      keys.push(_createCartProKey(pro))
    })
    outMenuPros.map(pro => {
      keys.push(_createOutMenuCartProKey(pro))
    })
    return keys;
  },

  /**
   * 对比两个餐品是否相等 proKey refKeys comboKeys 完全相同即为相等
   * @param {*} key1 
   * @param {*} key2 
   * @returns 
   */
  isSame(key1, key2) {
    if(key1.proKey !== key2.proKey) {
      return false
    }
    // 对比两个数组是否相同。【顺序允许不同，[1,2] [2,1]认为相同】
    const isSameArr = function(arr1, arr2) {
      if(arr1.length !== arr2.length) return false;
      for(let i = 0; i < arr1.length; i++) {
        let inArr2 = arr2.some(a2 => a2 === arr1[i])
        if(!inArr2) return false;
      }
      return true
    }

    if(!isSameArr(key1.reqKeys, key2.reqKeys)) {
      return false
    }
    if(!isSameArr(key1.comboKeys, key2.comboKeys)) {
      return false
    }

    return true;

  },

  isInCartProKeys(keyItem, cartProKeys) {
    return cartProKeys.some(key => this.isSame(key , keyItem))
  },

  isLengthChange(keyItem, keyItemKeys, cartProKeys) {
    let keyLen = keyItemKeys.filter(item => item.id === keyItem.id).length
    let carProKeyLen = cartProKeys.filter(item => item.id === keyItem.id).length
    return keyLen !== carProKeyLen;
  },

  matchProByKeyId(keyId, pro) {
    if(pro.pid > 0) {
      return keyId == pro.pid;
    }else {
      return keyId === pro.name;
    }
  },

    /**
   * 购物车增加是否改变的记号
   * @param {*} cartPro 购物车餐品
   * @param {*} compareCartProKeys 待比较的购物车keys【createCartProsKey方法产生的keys规则】
   */
  markCartProsChange(cartPros, outMenuCartPros, compareCartProKeys) {

    console.log('判断是有变化');


    let cartProList = [...cartPros];
    let outMenuCartProList = [...outMenuCartPros];

    let cartProKeys = this.createCartProsKey(cartPros);
    let outMenuProKeys = this.createCartProsKey(outMenuCartPros);
    
    // 恢复初始标记
    [...cartPros, ...outMenuCartProList].map(pro => {
      pro.originIsChange = false;
    })

    
    /**
     * keysItem: {outMenu: Boolean, proKey: String, refKeys: [], comboKeys: []}
     * 待比较的购物车keys分成容错跟非容错区别处理
     * 如果餐品A容错改变，容错标记。并且联动非容错餐品A改变
     */
    let compareOutMenuKeys = [],
        compareKeys = [];
    compareCartProKeys.map(item => {
      item.outMenu ? compareOutMenuKeys.push(item) : compareKeys.push(item)
    })
    
    compareOutMenuKeys.map(keyItem => {
      let isChangePro = !this.isInCartProKeys(keyItem, outMenuProKeys); // 原订单的餐品在购物车中找不回来了，则说明一边画
      if(isChangePro) {
        // 自身标记改变，并且联动相同的餐品外壳也标记改变
        // let beMarkOutMenuCartPros = [], beMarkMatchCartPros = []; // 通过可以key来找匹配购物车的餐品
        
        for (let i = 0; i < outMenuCartProList.length; i++) {
          let outMenuPro = outMenuCartProList[i];
          // 从待对比的集合挪出来，并标记改变
          if(this.matchProByKeyId(keyItem.id, outMenuPro)) {
            outMenuPro.originIsChange = true;
            outMenuCartProList.splice(i, 1)
            // beMarkOutMenuCartPros.push(beMarkPro);
            i--
          }
        }
        for (let i = 0; i < cartProList.length; i++) {
          let pro = cartProList[i];
          // 从待对比的集合挪出来，并标记改变
          if(this.matchProByKeyId(keyItem.id, pro)) {
            pro.originIsChange = true;
            cartProList.splice(i, 1)
            // beMarkOutMenuCartPros.push(beMarkPro);
            i--
          }
        }
        
      }
    })
    
    compareKeys.map(keyItem => {
      let isChangeProLen = this.isLengthChange(keyItem, compareKeys, cartProKeys); // 一个餐品在原订单的长度不等于在购物车的长度，则说明已变化
      let isChangePro = !this.isInCartProKeys(keyItem, cartProKeys); // 原订单的餐品在购物车中找不回来了，则说明已变化
      if(isChangeProLen || isChangePro) {
        // 自身标记改变，并且联动相同的餐品外壳也标记改变
        // let beMarkOutMenuCartPros = [], beMarkMatchCartPros = []; // 通过可以key来找匹配购物车的餐品
        
        for (let i = 0; i < outMenuCartProList.length; i++) {
          let outMenuPro = outMenuCartProList[i];
          // 从待对比的集合挪出来，并标记改变
          if(this.matchProByKeyId(keyItem.id, outMenuPro)) {
            let beMarkPro = outMenuCartProList.splice(i, 1)
            outMenuPro.originIsChange = true;
            // beMarkOutMenuCartPros.push(beMarkPro);
            i--
          }
        }
        for (let i = 0; i < cartProList.length; i++) {
          let pro = cartProList[i];
          // 从待对比的集合挪出来，并标记改变
          if(this.matchProByKeyId(keyItem.id, pro)) {
            let beMarkPro = cartProList.splice(i, 1)
            pro.originIsChange = true;
            // beMarkOutMenuCartPros.push(beMarkPro);
            i--
          }
        }
        
      }
    })

  },
}





export default cartProCompareHelper;


// WEBPACK FOOTER //
// ./../../plugins/utils/cartProHelper.js